<script>
import ProToast from '$common/ProToast'
import Loading from '$common/Loading'
import ModalsMain from '$modals/Main'
export default {
  name: 'App',
  components: {
    'pro-toast': ProToast,
    'loading': Loading,
    'modals-main': ModalsMain,
  },
  methods: {
    getUser (uid) {
      return new Promise(async (resolve, reject) => {
        const user = (await this.$firestore.collection('users').doc(uid).get()).data()
        return resolve(user)
      })
    },
    decideNextRoute (type) {
      const ditchTheseRoutes = [
        'ApplyMain',
        'Home',
        'ResetPassword',
      ]

      if (!ditchTheseRoutes.includes(this.$route.name)) return
      let defaultRoute = ''
      // const defaultRoute = {
      //   GUARDIAN: 'GuardianDashboard',
      //   ADMIN: 'AdminMain',
      // }[type]
      if (type.includes('GUARDIAN') || type.includes('ADULT_STUDENT')) defaultRoute = 'GuardianDashboard' // for now
      if (type.includes('ADMIN')) defaultRoute = 'AdminMain'
      if (defaultRoute === this.$route.name) return //don't want to have a duplicate route error

      this.$router.push({name: defaultRoute})
    },
    async listenForUser () {
      this.$auth.onAuthStateChanged(async (auth) => {
        if (auth) {
          const user = await this.getUser(auth.uid)
          if (!user) {
            this.$toast({copy: 'No proper user associated with that login.', class: 'alert'})
            console.log('user: ', user)
            return this.$store.commit('logout')
          }

          // on success, commit entities to store
          this.$store.commit('update', {auth, user})
          this.decideNextRoute(user.user_type)
          
        }
      })
    },
  },
  mounted () {
    this.listenForUser()
  },
}
</script>


<template lang='pug'>
  #app
    modals-main
    router-view
    pro-toast
    loading
</template>

<style lang="sass">
  body
    background-color: white
    margin: 0
    font-family: $font-1
    overflow-x: hidden
    
  #app
    position: relative

  .pro-button
    padding: 8px 15px
    min-width: 100px
    width: fit-content
    font-size: 14px
    font-family: $font-1
    text-align: center
    cursor: pointer
    user-select: none
    color: white
    border-radius: 0.5rem
    box-sizing: border-box
    &.minor
      background-color: $orange
      //border: $orange thick solid
    &.major
      @extend .cs-gradient
    &.outline
      border: thin solid black
    &.sbcs-orange
      background-color: $sbcs-orange
      font-weight: bold
  .spin-me
    animation-name: spin
    animation-duration: 1000ms
    animation-iteration-count: infinite
    animation-timing-function: linear
  
  @keyframes spin
    from
        transform: rotate(0deg)
    to
        transform: rotate(360deg)
</style>
